/**
 * What-If CONFIRM canvas state (design doc executive-view-design/
 * EXEC_WHATIF_v1_design.md §4 CONFIRM row).
 *
 * Deliberately near-empty: the sentence is already assembled in the
 * Control Bar below, so the canvas's only job is to point the eye down
 * at it. One light secondary-text line + a subtle down-arrow, both
 * centered. Entered from HOME on an example seed or any manual bar
 * edit (WhatIfView owns that transition rule); exited by Run (→
 * PREPARING) or the "← Examples & recents" affordance (→ HOME, form
 * retained).
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { ArrowDownward } from '@mui/icons-material';

interface ConfirmStateProps {
  // Status line of a reopened non-completed run ("Cancelled — nothing
  // was applied."), rendered above the standard prompt so the canvas
  // says why it moved here (2026-08-23: every recent click navigates).
  notice?: string;
}

const ConfirmState: React.FC<ConfirmStateProps> = ({ notice }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      flex: 1,
      minHeight: 240,
    }}
  >
    {notice && (
      <Typography variant="body1" color="text.secondary">
        {notice}
      </Typography>
    )}
    <Typography variant="body1" color="text.secondary">
      Review your what-if below, then run it.
    </Typography>
    <ArrowDownward sx={{ color: 'text.secondary', opacity: 0.6 }} />
  </Box>
);

export default ConfirmState;
